import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { PickGrades } from "../../supabase/functions/_shared/picksRanking.ts";

export interface SuggestedPick {
  id: string;
  name: string;
  slug: string | null;
  area: string | null;
  work_readiness_score: number | null;
  grades: PickGrades;
  for_you: boolean;
}

/**
 * The 3 Your picks cards, ranked and graded by the suggested-picks-grades
 * function so the cards and their grades always come from one answer. No
 * place ("Not now") returns the highest scored cafés.
 */
export function useSuggestedPicks(opts: { geo: { lat: number; lng: number } | null; priorities: string[] }) {
  const { geo, priorities } = opts;
  const sorted = [...priorities].sort();
  return useQuery({
    queryKey: ["suggested-picks", geo?.lat ?? null, geo?.lng ?? null, sorted.join(",")],
    staleTime: 5 * 60 * 1000,
    retry: 1,
    queryFn: async (): Promise<SuggestedPick[]> => {
      const body: Record<string, unknown> = { priorities: sorted };
      if (geo) { body.lat = geo.lat; body.lng = geo.lng; }
      const { data, error } = await supabase.functions.invoke("suggested-picks-grades", { body });
      if (error) throw error;
      return ((data as { cafes?: SuggestedPick[] })?.cafes ?? []).slice(0, 3);
    },
  });
}
